export default __webpack_public_path__ + "static/media/WF.95747314.svg";